@if (isEditMode()) {
<div class="edit-mode-bar">
    <div class="edit-mode-info">
        <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
        <span>Bearbeitungsmodus – Bestellung ist für andere Benutzer gesperrt</span>
    </div>

    <div class="edit-mode-actions">
        <button type="button" class="cancel-button" (click)="cancelEditMode()">
            <mat-icon fontSet="material-icons-outlined">close</mat-icon>
            Abbrechen
        </button>

        <button type="button" class="save-button" (click)="saveBestellung()">
            <mat-icon fontSet="material-icons-outlined">save</mat-icon>
            Speichern
        </button>
    </div>
</div>
}

<div class="bestellung-detail-layout">

    <div class="bestellung-detail-page" [class.edit-mode-active]="isEditMode()">
        <button type="button" class="back-link" (click)="backToBestellungen()">
            <mat-icon fontSet="material-icons-outlined">arrow_back</mat-icon>
            Zurück zu Bestellungen
        </button>

        <div class="detail-header">
            <div class="header-top">
                <h1>{{ bestellung().filiale }}</h1>

                <div class="edit-action-wrapper" [class.edit-button-hidden]="isEditMode()">
                    <button type="button" class="edit-button" [disabled]="!canStartEditMode()"
                        (click)="enableEditMode()">

                        <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
                        Bestellung bearbeiten

                    </button>

                    @if (!canStartEditMode()) {
                    <small class="edit-window-hint">
                        {{ editWindowHint() }}
                    </small>
                    }
                </div>
            </div>

            <div class="delivery-box">
                <mat-icon fontSet="material-icons-outlined">calendar_month</mat-icon>
                <span>Liefertag: {{ bestellung().lieferdatum }}</span>

                <mat-icon fontSet="material-icons-outlined">schedule</mat-icon>
                <span class="remaining-time">
                    Noch {{ bestellung().restzeit }}
                </span>
            </div>
        </div>

        <div class="toolbar">
            <div class="tab-container">
                <button type="button" class="tab" [class.active]="activeTab() === 'artikel'"
                    (click)="setActiveTab('artikel')">
                    Artikel
                </button>

                <button type="button" class="tab" [class.active]="activeTab() === 'warengruppen'"
                    (click)="setActiveTab('warengruppen')">
                    Warengruppen
                </button>

                @if (isEditMode()) {
                <button type="button" class="add-article-button" (click)="openAddArtikelDialog()">

                    <mat-icon fontSet="material-icons-outlined">add</mat-icon>
                    Artikel hinzufügen

                </button>
                }
            </div>

            <div class="search-box">
                <mat-icon fontSet="material-icons-outlined">search</mat-icon>

                <input type="text" placeholder="Artikel suchen..." [value]="searchTerm()"
                    (input)="updateSearchTerm($event)" />

                @if (searchTerm()) {
                <button type="button" class="search-clear-button" (click)="searchTerm.set('')">

                    <mat-icon fontSet="material-icons-outlined">
                        close
                    </mat-icon>

                </button>
                }
            </div>
        </div>

        <div class="tab-content-container" [class.warengruppen-active]="activeTab() === 'warengruppen'"
            [class.empty-search-result]="
                !isLoading() &&
                filteredArtikel().length === 0
        ">

            @if (activeTab() === 'artikel') {
            <div class="table-container">

                @if (isLoading()) {
                <table class="artikel-table artikel-table-skeleton">
                    <thead>
                        <tr>
                            <th class="icon-column"></th>
                            <th>ART.NR</th>
                            <th>NAME</th>
                            <th>PREIS / €</th>
                            <th>VORSCHLAG</th>
                            <th>BESTELLMENGE</th>
                            <th>EINHEIT / LOS</th>
                            <th>½ PKG.</th>
                            <th>MIN</th>
                            <th>MAX</th>
                        </tr>
                    </thead>

                    <tbody>
                        @for (row of skeletonRows; track $index) {
                        <tr>
                            <td>
                                <span class="skeleton skeleton-icon"></span>
                            </td>

                            <td>
                                <span class="skeleton skeleton-text skeleton-text-small"></span>
                            </td>

                            <td>
                                <div class="skeleton-cell-stack">
                                    <span class="skeleton skeleton-text skeleton-text-strong"></span>
                                    <span class="skeleton skeleton-text skeleton-text-medium"></span>
                                </div>
                            </td>

                            <td>
                                <span class="skeleton skeleton-text skeleton-text-small"></span>
                            </td>

                            <td>
                                <span class="skeleton skeleton-text skeleton-text-small"></span>
                            </td>

                            <td>
                                <span class="skeleton skeleton-quantity"></span>
                            </td>

                            <td>
                                <span class="skeleton skeleton-text skeleton-text-medium"></span>
                            </td>

                            <td>
                                <span class="skeleton skeleton-checkbox"></span>
                            </td>

                            <td>
                                <span class="skeleton skeleton-text skeleton-text-small"></span>
                            </td>

                            <td>
                                <span class="skeleton skeleton-text skeleton-text-small"></span>
                            </td>
                        </tr>
                        }
                    </tbody>
                </table>

                } @else if (filteredArtikel().length === 0) {

                <div class="empty-article-state">
                    <mat-icon fontSet="material-icons-outlined">
                        search_off
                    </mat-icon>

                    <span>Kein Artikel gefunden.</span>
                </div>

                } @else {

                <table>
                    <thead>
                        <tr>
                            <th class="icon-column"></th>

                            <th>
                                <button type="button" class="sort-header"
                                    [class.sort-header-active]="isArtikelSortActive('nummer')"
                                    (click)="setArtikelSort('nummer')">

                                    <span>ART.NR</span>

                                    <mat-icon fontSet="material-icons-outlined">
                                        {{ getArtikelSortIcon('nummer') }}
                                    </mat-icon>

                                </button>
                            </th>

                            <th>
                                <button type="button" class="sort-header"
                                    [class.sort-header-active]="isArtikelSortActive('name')"
                                    (click)="setArtikelSort('name')">

                                    <span>NAME</span>

                                    <mat-icon fontSet="material-icons-outlined">
                                        {{ getArtikelSortIcon('name') }}
                                    </mat-icon>

                                </button>
                            </th>

                            <th>
                                <button type="button" class="sort-header"
                                    [class.sort-header-active]="isArtikelSortActive('preis')"
                                    (click)="setArtikelSort('preis')">

                                    <span>PREIS / €</span>

                                    <mat-icon fontSet="material-icons-outlined">
                                        {{ getArtikelSortIcon('preis') }}
                                    </mat-icon>

                                </button>
                            </th>

                            <th>
                                <button type="button" class="sort-header"
                                    [class.sort-header-active]="isArtikelSortActive('vorschlag')"
                                    (click)="setArtikelSort('vorschlag')">

                                    <span>VORSCHLAG</span>

                                    <mat-icon fontSet="material-icons-outlined">
                                        {{ getArtikelSortIcon('vorschlag') }}
                                    </mat-icon>

                                </button>
                            </th>

                            <th>
                                <button type="button" class="sort-header"
                                    [class.sort-header-active]="isArtikelSortActive('menge')"
                                    (click)="setArtikelSort('menge')">

                                    <span>BESTELLMENGE</span>

                                    <mat-icon fontSet="material-icons-outlined">
                                        {{ getArtikelSortIcon('menge') }}
                                    </mat-icon>

                                </button>
                            </th>

                            <th>
                                <button type="button" class="sort-header"
                                    [class.sort-header-active]="isArtikelSortActive('einheit')"
                                    (click)="setArtikelSort('einheit')">

                                    <span>EINHEIT / LOS</span>

                                    <mat-icon fontSet="material-icons-outlined">
                                        {{ getArtikelSortIcon('einheit') }}
                                    </mat-icon>

                                </button>
                            </th>

                            <th>
                                <button type="button" class="sort-header"
                                    [class.sort-header-active]="isArtikelSortActive('pkg')"
                                    (click)="setArtikelSort('pkg')">

                                    <span>½ PKG.</span>

                                    <mat-icon fontSet="material-icons-outlined">
                                        {{ getArtikelSortIcon('pkg') }}
                                    </mat-icon>

                                </button>
                            </th>

                            <th>
                                <button type="button" class="sort-header"
                                    [class.sort-header-active]="isArtikelSortActive('min')"
                                    (click)="setArtikelSort('min')">

                                    <span>MIN</span>

                                    <mat-icon fontSet="material-icons-outlined">
                                        {{ getArtikelSortIcon('min') }}
                                    </mat-icon>

                                </button>
                            </th>

                            <th>
                                <button type="button" class="sort-header"
                                    [class.sort-header-active]="isArtikelSortActive('max')"
                                    (click)="setArtikelSort('max')">

                                    <span>MAX</span>

                                    <mat-icon fontSet="material-icons-outlined">
                                        {{ getArtikelSortIcon('max') }}
                                    </mat-icon>

                                </button>
                            </th>
                        </tr>
                    </thead>

                    <tbody>

                        @for (item of filteredArtikel(); track $index) {

                        <tr class="article-row" [class.article-row-selected]="activeArtikelNumber() === item.nummer"
                            [class.article-row-invalid]="isEditMode() && item.changed && getMengeError(item)"
                            (click)="selectArtikel(item.nummer)">

                            <td>
                                @if (item.readonly) {

                                <mat-icon class="row-state-icon lock-icon" fontSet="material-icons-outlined">
                                    lock
                                </mat-icon>

                                } @else if (item.saved) {

                                <mat-icon class="row-state-icon saved-icon" fontSet="material-icons-outlined">
                                    check_circle
                                </mat-icon>

                                } @else if (item.changed) {

                                <mat-icon class="row-state-icon changed-icon" fontSet="material-icons-outlined">
                                    edit
                                </mat-icon>

                                } @else {

                                <mat-icon class="row-state-icon remove-icon" fontSet="material-icons-outlined">
                                    remove_circle_outline
                                </mat-icon>

                                }
                            </td>

                            <td>{{ item.nummer }}</td>

                            <td>
                                <div class="article-name">
                                    <strong>{{ item.name }}</strong>
                                    <span>{{ item.beschreibung }}</span>

                                    @if (
                                    isEditMode() &&
                                    item.changed &&
                                    getMengeError(item)
                                    ) {
                                    <span class="quantity-error">
                                        <mat-icon fontSet="material-icons-outlined">
                                            warning
                                        </mat-icon>

                                        {{ getMengeError(item) }}
                                    </span>
                                    }
                                </div>
                            </td>

                            <td>{{ item.preis }}</td>

                            <td>{{ item.vorschlag }}</td>

                            <td>
                                <div class="quantity-cell-content">

                                    @if (isEditMode()) {

                                    <div class="quantity-editor">

                                        <button type="button" class="quantity-button" [disabled]="item.readonly"
                                            (click)="decreaseMenge(item.nummer); $event.stopPropagation()">

                                            <mat-icon fontSet="material-icons-outlined">
                                                remove
                                            </mat-icon>

                                        </button>

                                        <div class="quantity-input-stack">

                                            <input type="number" class="quantity-input"
                                                [value]="item.changed || item.saved ? (item.menge ?? '') : ''"
                                                [placeholder]="(item.menge ?? item.vorschlag).toString()" [attr.min]="0"
                                                [attr.max]="getInputMax(item)" [attr.step]="getQuantityInputStep(item)"
                                                [disabled]="item.readonly" (click)="$event.stopPropagation()"
                                                (input)="updateMengeFromInput(item.nummer, $event)"
                                                (keydown.enter)="focusNextQuantityInput($event)" />

                                            @if (getQuantityCalculationLabel(item); as calculationLabel) {
                                            <small class="quantity-calculation">
                                                {{ calculationLabel }}
                                            </small>
                                            }

                                        </div>

                                        <button type="button" class="quantity-button" [disabled]="item.readonly"
                                            (click)="increaseMenge(item.nummer); $event.stopPropagation()">

                                            <mat-icon fontSet="material-icons-outlined">
                                                add
                                            </mat-icon>

                                        </button>

                                        <button type="button" class="recommendation-button"
                                            title="Empfehlung übernehmen"
                                            [disabled]="item.readonly || !hasLoadedRecommendation(item.nummer)"
                                            (click)="applyRecommendation(item.nummer); $event.stopPropagation()">

                                            <mat-icon fontSet="material-icons-outlined">
                                                auto_awesome
                                            </mat-icon>

                                        </button>

                                    </div>

                                    } @else {

                                    @if (item.menge !== null) {

                                    <span class="quantity-badge"
                                        [class.quantity-badge-placeholder]="!item.changed && !item.saved">

                                        {{ item.menge }}

                                    </span>

                                    } @else {

                                    <span class="quantity-badge quantity-badge-placeholder">
                                        {{ item.vorschlag }}
                                    </span>

                                    }


                                    }

                                </div>
                            </td>

                            <td>{{ item.einheit }}</td>

                            <td>
                                @if (item.pkg) {
                                <span class="pkg-check" aria-label="Halbe Packung">
                                    ✓
                                </span>
                                }
                            </td>

                            <td>{{ item.min ?? '—' }}</td>

                            <td>{{ item.max ?? '—' }}</td>
                        </tr>

                        }
                    </tbody>
                </table>

                }

            </div>
            }

            @if (activeTab() === 'warengruppen') {

            <app-warengruppen-tab [artikel]="artikel()" [searchTerm]="searchTerm()" [isEditMode]="isEditMode()"
                [isLoading]="isLoading()" [activeArtikelNumber]="activeArtikelNumber()"
                [getMengeError]="getMengeErrorForView" [getQuantityInputStep]="getQuantityInputStepForView"
                [getInputMin]="getInputMinForView" [getInputMax]="getInputMaxForView"
                [getActualQuantity]="getActualQuantityForView"
                [getQuantityCalculationLabel]="getQuantityCalculationLabelForView"
                (artikelSelected)="selectArtikel($event)" (mengeDecreased)="decreaseMenge($event)"
                (mengeIncreased)="increaseMenge($event)"
                (mengeUpdated)="updateMengeFromInput($event.artikelNummer, $event.event)"
                (quantityEnterPressed)="focusNextQuantityInput($event)">
            </app-warengruppen-tab>

            }

        </div>

        <div class="footer">
            <span>Gesamtbestellwert</span>

            <strong>
                {{ gesamtbestellwert() }}
            </strong>
        </div>

        @if (isAddArtikelDialogOpen()) {

        <app-add-artikel-dialog [availableArtikel]="availableArtikel()"
            [existingArtikelNumbers]="existingArtikelNumbers()" (closed)="closeAddArtikelDialog()"
            (artikelSelected)="addArtikelToBestellung($event)">
        </app-add-artikel-dialog>

        }

    </div>

    @if (isCompactView() && isAssistantOpen()) {
    <div class="assistant-backdrop" (click)="closeAssistant()">
    </div>
    }

    @if (!isCompactView() || isAssistantOpen()) {

    <app-bestellassistent [artikel]="selectedArtikel()" [bestellungId]="bestellungId()"
        [refreshKey]="assistantRefreshKey()" (recommendationLoaded)="setLoadedRecommendation($event)"
        (closed)="closeAssistant()">
    </app-bestellassistent>

    }

</div>